import {
  Button,
  Colors,
  Cross,
  Modal,
  NavigationIcon,
  NavigationNotification,
  StatusBox,
  StatusBoxWrap,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { getTimeForNewAssessment } from 'services/historyMode/historyMode'
import styles from './style.module.scss'
import { IButtonColor } from './types'

interface IProps extends Pick<RouteComponentProps, 'history'> {
  age: number
  open: boolean
  questionnairesCount: number | null
  gamesCount: number | null
  showQuestionnaries: boolean
  showGames: boolean
  onClose: () => void
  onSubmit: () => void
  relevantAssessment: number
}

interface IState {}

export class ProgressionEvaluationModal extends React.Component<
  IProps,
  IState
> {
  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.pathname)
    window.addEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  renderDescription(): {
    description
    isUp?: boolean
  } {
    const {
      questionnairesCount,
      gamesCount,
      showQuestionnaries,
      showGames,
      relevantAssessment
    } = this.props

    const isQuestionnaries: boolean = !!(
      showQuestionnaries &&
      questionnairesCount &&
      questionnairesCount > 0
    )
    const isGames: boolean = !!(showGames && gamesCount && gamesCount > 0)
    let isUp
    let description =
      isQuestionnaries && isGames
        ? `You have ${questionnairesCount} questionnaires and ${gamesCount} games left to complete`
        : isQuestionnaries
        ? `You have ${questionnairesCount} unfinished questionnaires`
        : isGames
        ? `You have ${gamesCount} games left to complete`
        : null
    if (!description) {
      description = `Next evaluation in: ${getTimeForNewAssessment(
        relevantAssessment
      )}`
      isUp = true
    }
    return {
      description: <Typography type="text">{description}</Typography>,
      isUp
    }
  }

  getStatusIcon = (count: number) =>
    count === 0 ? (
      <NavigationNotification
        icon="checkmark"
        backgroundColor={Colors.pinkAccent}
      />
    ) : (
      <NavigationNotification number={count} />
    )

  setActive = () => {
    if (!status) {
      const { onClose } = this.props
      window.removeEventListener('popstate', this.onBackBrowserBtnEvent)

      // i added this check here because when questionaries
      // are completed pressing the back button send the user to the
      // abilities page and not the child's questionaries page because it
      // goes through a redirect(/questionnaries -> /:childId/abilites)
      // since the questionaries has finished.
      // if (questionnairesCount) {
      //   window.history.back()
      // }
      onClose()
    }
  }

  render() {
    const {
      open,
      questionnairesCount,
      gamesCount,
      showQuestionnaries,
      showGames,
      onSubmit
    } = this.props
    const { text, color } = this.renderButtonParams()
    const { description, isUp } = this.renderDescription()

    return (
      <Modal
        active={open}
        setActive={() => this.setActive()}
        baseClassName={styles.wrap}
        x={<Cross size="big" color={Colors.unselected} />}
      >
        <Typography type="title" size="big">
          Evaluation Status
        </Typography>

        {isUp && description}
        <StatusBoxWrap>
          {showQuestionnaries && questionnairesCount !== null && (
            <StatusBox
              onClick={() => {
                if (questionnairesCount !== 0) {
                  onSubmit()
                }
              }}
              icon={<NavigationIcon type="Questionnaires" active={true} />}
              statusIcon={this.getStatusIcon(questionnairesCount)}
            />
          )}
          {showGames && gamesCount !== null && (
            <StatusBox
              onClick={() => {
                if (gamesCount !== 0) {
                  onSubmit()
                }
              }}
              icon={<NavigationIcon type="Games" active={true} />}
              statusIcon={this.getStatusIcon(gamesCount)}
            />
          )}
        </StatusBoxWrap>
        {!isUp && description}
        <Button color={color} onClick={onSubmit}>
          {text}
        </Button>
      </Modal>
    )
  }

  private renderButtonParams(): {
    text: string
    color?: IButtonColor
  } {
    const {
      showGames,
      showQuestionnaries,
      gamesCount,
      questionnairesCount,
      age
    } = this.props
    let color: IButtonColor = 'pink'
    let text = ''

    if (showGames && gamesCount !== 0) {
      text =
        gamesCount && gamesCount > 0 && gamesCount !== 8
          ? 'Continue Games'
          : 'Start Games'
    } else if (showQuestionnaries && questionnairesCount !== 0) {
      text =
        questionnairesCount === this.getQuestionnairesCount(age)
          ? 'Start Questionnaires'
          : 'Continue Questionnaires'
    } else {
      text = 'Back to Abilities Map'
      color = 'white'
    }
    return { text, color }
  }

  private getQuestionnairesCount(age: number) {
    if (age >= 0 && age <= 2) {
      return 2
    } else if (age >= 3 && age <= 7) {
      return 5
    } else if (age === 8) {
      return 3
    }
    return 2
  }
}



// WEBPACK FOOTER //
// ./src/components/ProgressionEvaluationModal/index.tsx